import React, { useState } from "react";
import { Share2 } from "lucide-react";

const ShareButton = ({ text = "Compartir", url = window.location.href }) => {
    const [copiado, setCopiado] = useState(false);

    const handleClick = async () => {
        const isMobile = /Mobi|Android/i.test(navigator.userAgent);

        if (navigator.share && isMobile) {
            try {
                await navigator.share({ title: document.title, url });
            } catch (err) {
                console.error("Error al compartir:", err);
            }
        } else {
            try {
                await navigator.clipboard.writeText(url);
                setCopiado(true);
                setTimeout(() => setCopiado(false), 2000); // vuelve al texto original tras 2 segundos
            } catch (err) {
                console.error("Error al copiar el enlace:", err);
            }
        }
    };

    return (
        <button
            onClick={handleClick}
            className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 text-sm transition-all"
        >
            <Share2 size={16} />
            {copiado ? "Copiado ✅" : text}
        </button>
    );
};

export default ShareButton;
